import { createAction } from 'modules/redux-store';

export const programActions = {
  setCategory: (categories: Record<ProgramCategory, boolean>) =>
    createAction('program/SET_CATEGORY', { categories }),
};
